"use client";

import { useTranslations } from "@/hooks/use-translations";
import { Card } from "@heroui/react";
import Image from "next/image";


export default function People() {
  const t = useTranslations();

  if (!t) return null;

  return (
    <section id="people" className="bg-body-light dark:bg-body-dark min-h-[400px]">
      <div className="container mx-auto">
        <div className="text-center mb-12 px-4">
          <h2 className="font-bold mb-4 text-3xl desktop:text-5xl">
            {t.people.title}
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-lg desktop:text-xl">
            {t.people.subtitle}
          </p>
        </div>

        <ul className="grid grid-cols-1 desktop:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <li>
            <Item
              icon={"/assets/computer.png"}
              title={t.people.freelancers.title}
              description={
                <>
                  <p className="font-bold">
                    {t.people.freelancers.problem}
                  </p>
                  <p className="mt-2">
                    {t.people.freelancers.solution}
                  </p>
                </>
              }
              highlight={t.people.freelancers.highlight}
            />
          </li>

          <li>
            <Item
              icon={"/assets/building.png"}
              title={t.people.remote.title}
              description={
                <>
                  <p className="font-bold">
                    {t.people.remote.problem}
                  </p>
                  <p className="mt-2">
                    {t.people.remote.solution}
                  </p>
                </>
              }
              highlight={t.people.remote.highlight}
            />
          </li>
        </ul>
      </div>
    </section>
  );
}

function Item({
  icon,
  title,
  description,
  highlight,
}: {
  icon: string;
  title: React.ReactNode;
  description: React.ReactNode;
  highlight: React.ReactNode;
}) {
  return (
    <Card className="flex flex-col items-center text-center p-6 gap-4 rounded-xl h-full">
      <Image src={icon} alt={icon} className="w-16 h-16" width={64} height={64} loading="lazy" sizes="64px" />
      <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
        {title}
      </h3>
      <div className="text-gray-600 dark:text-gray-300 flex-1">{description}</div>
      <span className="text-sm font-medium text-gray-900 dark:text-gray-100 px-3 rounded-full">
        {highlight}
      </span>
    </Card>
  );
}
